import ThemeProviderWrapper from './container'

export default ThemeProviderWrapper
